var R = require('ramda'); // Utility functions for data formatting


var toInt = function toInt(val) {
  return parseInt(val, 10);
};

var toFixed = R.curry(function (amount, value) {
  if (typeof value.toFixed === 'function') {
    return value.toFixed(amount);
  }

  return value;
});
module.exports = {
  toInt: toInt,
  toFixed: toFixed
};